export default "__VITE_ASSET__ee10966a__"